export const CHANGE_EMAIL_CONTACTS = 'CHANGE_EMAIL_CONTACTS'
export const RESET_EMAIL_CONTACTS = 'RESET_EMAIL_CONTACTS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const EMAIL_CONTACT_REQUESTED = 'EMAIL_CONTACT_REQUESTED'
export const COMPANY_CONTACTS_FETCH_REQUESTED = 'COMPANY_CONTACTS_FETCH_REQUESTED'
export const ADD_FILE = 'ADD_FILE'
export const REMOVE_FILE = 'REMOVE_FILE'
